import React from 'react';
import styled from 'styled-components';
import Component from './component';

const PreviewExpected = ({ field = 'dateOfArrival', ...props }) => (
  <Component field={field} {...props} Element="div" prepend="Verwacht " />
);

export default styled(PreviewExpected)``;
